import styled from 'styled-components';


/*
========================================
PÁGINA
========================================
*/

export const PaginaConfirmacion =
    styled.div`

        min-height:
            100vh;

        background:
            #F7FAFA;

        color:
            #646464;


        *,
        *::before,
        *::after {

            box-sizing:
                border-box;

        }

    `;


/*
========================================
HEADER
========================================
*/

export const HeaderConfirmacion =
    styled.header`

        width:
            100%;

        min-height:
            76px;

        padding:
            14px 5%;

        display:
            flex;

        align-items:
            center;

        justify-content:
            space-between;

        gap:
            20px;

        background:
            #FFFFFF;

        border-bottom:
            1px solid
            rgba(
                35,
                170,
                175,
                0.15
            );

    `;


export const LogoLink =
    styled.a`

        display:
            inline-flex;

        align-items:
            center;

        text-decoration:
            none;

    `;


export const Logo = styled.img`

    display:
        block;

    width:
        170px;

    height:
        auto;

    max-width:
        100%;

    object-fit:
        contain;

`;


export const LinkLogin =
    styled.a`

        min-height:
            42px;

        padding:
            0 20px;

        display:
            inline-flex;

        align-items:
            center;

        justify-content:
            center;

        border:
            1.5px solid
            #23AAAF;

        border-radius:
            10px;

        background:
            #FFFFFF;

        color:
            #23AAAF;

        font-size:
            0.9rem;

        font-weight:
            750;

        text-decoration:
            none;

        transition:
            0.16s ease;


        &:hover {

            background:
                rgba(
                    35,
                    170,
                    175,
                    0.07
                );

        }


        @media (
            max-width:
                600px
        ) {

            display:
                none;

        }

    `;


/*
========================================
LAYOUT
========================================
*/

export const ContenedorConfirmacion =
    styled.main`

        width:
            min(
                980px,
                calc(
                    100% - 40px
                )
            );

        margin:
            0 auto;

        padding:
            60px 0 80px;

        display:
            grid;

        grid-template-columns:
            minmax(
                270px,
                0.85fr
            )
            minmax(
                0,
                1.15fr
            );

        align-items:
            stretch;

        gap:
            28px;


        @media (
            max-width:
                800px
        ) {

            width:
                min(
                    620px,
                    calc(
                        100% - 28px
                    )
                );

            padding:
                35px 0 60px;

            grid-template-columns:
                1fr;

        }


        @media (
            max-width:
                520px
        ) {

            width:
                calc(
                    100% - 20px
                );

            padding:
                20px 0 45px;

        }

    `;


/*
========================================
PANEL INFORMATIVO
========================================
*/

export const PanelInformativo =
    styled.aside`

        min-height:
            460px;

        padding:
            34px;

        display:
            flex;

        flex-direction:
            column;

        overflow:
            hidden;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.20
            );

        border-radius:
            18px;

        background:
            rgba(
                35,
                170,
                175,
                0.09
            );


        @media (
            max-width:
                800px
        ) {

            min-height:
                auto;

        }


        @media (
            max-width:
                600px
        ) {

            display:
                none;

        }

    `;


export const EtiquetaPanel =
    styled.div`

        margin-bottom:
            10px;

        color:
            #655EE8;

        font-size:
            0.73rem;

        font-weight:
            850;

        letter-spacing:
            0.08em;

    `;


export const TituloPanel =
    styled.h1`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            2rem;

        font-weight:
            800;

        line-height:
            1.15;

    `;


export const TextoPanel =
    styled.p`

        margin:
            16px 0 0;

        color:
            #646464;

        font-size:
            0.92rem;

        line-height:
            1.6;

    `;


export const IlustracionPanel =
    styled.img`

        width:
            min(
                100%,
                280px
            );

        height:
            auto;

        margin:
            auto auto 0;

        padding-top:
            30px;

        object-fit:
            contain;

    `;


/*
========================================
TARJETA
========================================
*/

export const TarjetaConfirmacion =
    styled.section`

        min-height:
            460px;

        padding:
            34px;

        display:
            flex;

        flex-direction:
            column;

        border:
            1px solid
            rgba(
                35,
                170,
                175,
                0.19
            );

        border-radius:
            18px;

        background:
            #FFFFFF;

        box-shadow:
            0 8px 30px
            rgba(
                0,
                0,
                0,
                0.045
            );


        @media (
            max-width:
                520px
        ) {

            min-height:
                auto;

            padding:
                24px 19px;

        }

    `;


export const EncabezadoTarjeta =
    styled.div`

        margin-bottom:
            23px;

    `;


export const TituloTarjeta =
    styled.h2`

        margin:
            0;

        color:
            #23AAAF;

        font-size:
            1.45rem;

        font-weight:
            800;

        line-height:
            1.25;

    `;


export const TextoTarjeta =
    styled.p`

        margin:
            7px 0 0;

        color:
            #646464;

        font-size:
            0.86rem;

        line-height:
            1.5;

    `;


/*
========================================
MENSAJES
========================================
*/

export const MensajeEstado =
    styled.div`

        margin-bottom:
            14px;

        padding:
            11px 13px;

        border:
            1px solid
            ${
                props =>
                    props.$error
                        ?
                        'rgba(215, 105, 112, 0.28)'
                        :
                    props.$exito
                        ?
                        'rgba(35, 170, 175, 0.26)'
                        :
                        'rgba(239, 195, 64, 0.32)'
            };

        border-radius:
            9px;

        background:
            ${
                props =>
                    props.$error
                        ?
                        'rgba(215, 105, 112, 0.07)'
                        :
                    props.$exito
                        ?
                        'rgba(35, 170, 175, 0.07)'
                        :
                        'rgba(239, 195, 64, 0.08)'
            };

        color:
            ${
                props =>
                    props.$error
                        ?
                        '#D76970'
                        :
                    props.$exito
                        ?
                        '#23AAAF'
                        :
                        '#646464'
            };

        font-size:
            0.8rem;

        font-weight:
            650;

        line-height:
            1.45;

    `;


/*
========================================
ACCIÓN PRINCIPAL
========================================
*/

export const BloqueAccion =
    styled.div`

        padding:
            10px 0 4px;

        display:
            flex;

        justify-content:
            flex-start;

    `;


export const BotonPrincipal =
    styled.button`

        min-height:
            43px;

        padding:
            9px 19px;

        border:
            1px solid
            #FC8906;

        border-radius:
            9px;

        background:
            #FC8906;

        color:
            #FFFFFF;

        font-family:
            inherit;

        font-size:
            0.84rem;

        font-weight:
            800;

        cursor:
            pointer;

        transition:
            0.16s ease;


        &:hover:not(
            :disabled
        ) {

            transform:
                translateY(
                    -1px
                );

            box-shadow:
                0 5px 14px
                rgba(
                    252,
                    137,
                    6,
                    0.20
                );

        }


        &:disabled {

            opacity:
                0.55;

            cursor:
                not-allowed;

        }


        @media (
            max-width:
                500px
        ) {

            width:
                100%;

        }

    `;


/*
========================================
SEPARADOR
========================================
*/

export const Separador =
    styled.div`

        width:
            100%;

        height:
            1px;

        margin:
            28px 0;

        background:
            rgba(
                100,
                100,
                100,
                0.11
            );

    `;


/*
========================================
REENVÍO
========================================
*/

export const BloqueReenvio =
    styled.div`

        width:
            100%;

    `;


export const PreguntaReenvio =
    styled.p`

        margin:
            0 0 5px;

        color:
            #646464;

        font-size:
            0.82rem;

        line-height:
            1.45;

    `;


export const BotonTexto =
    styled.button`

        padding:
            0;

        border:
            0;

        background:
            transparent;

        color:
            #655EE8;

        font-family:
            inherit;

        font-size:
            0.8rem;

        font-weight:
            750;

        cursor:
            pointer;

        text-decoration:
            underline;

        text-underline-offset:
            3px;

    `;


/*
========================================
FORMULARIO
========================================
*/

export const FormularioReenvio =
    styled.form`

        width:
            100%;

    `;


export const Campo =
    styled.div`

        display:
            flex;

        flex-direction:
            column;

        gap:
            6px;

    `;


export const Label =
    styled.label`

        color:
            #646464;

        font-size:
            0.76rem;

        font-weight:
            750;

    `;


export const Input =
    styled.input`

        width:
            100%;

        min-height:
            43px;

        padding:
            10px 12px;

        border:
            1.5px solid
            rgba(
                35,
                170,
                175,
                0.28
            );

        border-radius:
            9px;

        outline:
            none;

        background:
            #FAFCFC;

        color:
            #646464;

        font-family:
            inherit;

        font-size:
            0.86rem;

        transition:
            0.16s ease;


        &:focus {

            border-color:
                #23AAAF;

            background:
                #FFFFFF;

            box-shadow:
                0 0 0 3px
                rgba(
                    35,
                    170,
                    175,
                    0.08
                );

        }


        &:disabled {

            opacity:
                0.6;

        }

    `;


export const TextoError =
    styled.div`

        color:
            #D76970;

        font-size:
            0.74rem;

        font-weight:
            650;

    `;


/*
========================================
ACCIONES REENVÍO
========================================
*/

export const AccionesReenvio =
    styled.div`

        margin-top:
            17px;

        display:
            flex;

        justify-content:
            flex-end;

        flex-wrap:
            wrap;

        gap:
            8px;

    `;


export const BotonSecundario =
    styled.button`

        min-height:
            43px;

        padding:
            9px 17px;

        border:
            1px solid
            rgba(
                101,
                94,
                232,
                0.26
            );

        border-radius:
            9px;

        background:
            #FFFFFF;

        color:
            #655EE8;

        font-family:
            inherit;

        font-size:
            0.82rem;

        font-weight:
            750;

        cursor:
            pointer;


        &:hover:not(
            :disabled
        ) {

            background:
                rgba(
                    101,
                    94,
                    232,
                    0.06
                );

        }


        &:disabled {

            opacity:
                0.55;

        }


        @media (
            max-width:
                500px
        ) {

            width:
                100%;

        }

    `;


/*
========================================
LOGIN MOBILE
========================================
*/

export const TextoLoginMobile =
    styled.div`

        display:
            none;

        margin-top:
            auto;

        padding-top:
            30px;

        text-align:
            center;

        color:
            #646464;

        font-size:
            0.8rem;


        a {

            color:
                #655EE8;

            font-weight:
                750;

            text-decoration:
                none;

        }


        @media (
            max-width:
                600px
        ) {

            display:
                block;

        }

    `;